"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compile = void 0;
const React = require("react");
const AppProvider_1 = require("../../components/AppProvider");
const helpers_1 = require("../helpers");
function compile(appRootElement, providers, onRender) {
    const element = (0, helpers_1.constructElement)(providers, appRootElement);
    const dependencies = (0, helpers_1.collectDependencies)(providers);
    return onRender(React.createElement(AppProvider_1.AppProvider, { context: dependencies }, element), dependencies);
}
exports.compile = compile;
//# sourceMappingURL=compile.js.map